import { Link } from 'react-router-dom';
import styled from 'styled-components';

import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';

const ICON_SIZE = 32;

export const Container = styled.div``;

export const Title = styled(Heading)`
  display: block;
  margin-bottom: ${({ theme }) => theme.spacings.abs16}px;
`;

export const Subtitle = styled(Text)`
  display: block;
  margin-bottom: ${({ theme }) => theme.spacings.abs32}px;
`;

export const Root = styled.div`
  margin-bottom: ${({ theme }) => theme.spacings.abs32}px;
`;

const IconContainer = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.grey(3)};
  border-radius: 50%;
  display: flex;
  height: ${ICON_SIZE}px;
  width: ${ICON_SIZE}px;
  justify-content: center;
  margin-right: ${({ theme }) => theme.spacings.abs16}px;
  padding: ${({ theme }) => theme.spacings.abs8}px;
`;

export const BackButton = styled(IconContainer)`
  left: 0;
`;

const IconContainerLink = styled(Link)`
  align-items: center;
  background: ${({ theme }) => theme.colors.grey(3)};
  border-radius: 50%;
  display: flex;
  height: ${ICON_SIZE}px;
  justify-content: center;
  position: absolute;
  top: 0;
  width: ${ICON_SIZE}px;
`;

export const CloseButton = styled(IconContainerLink)`
  right: 0;
`;

export const Header = styled.div`
  height: ${ICON_SIZE}px;
  margin-bottom: ${({ theme }) => theme.spacings.abs32}px;
  position: relative;
`;

export const LoaderContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacings.abs64}px;
`;
